import * as React from "react";
import {observer} from "mobx-react";
import {CrudComponent} from "./CrudComponent";
import {ListTableStore} from "../../stores/ListTableStore";
import {ListTable} from "../list/ListTable";
import {Button} from "reactstrap";
import {FormStore} from "../../stores/FormStore";
import {debounce} from 'lodash';
import {observable} from "mobx";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {HasPermission} from "../HasPermission";
import {snakeCase} from "lodash";


class SearchForm {
    @observable search = '';
}

@observer
export class CrudList extends CrudComponent {
    listTableStore: ListTableStore;
    defaultSortColumn?: string;
    defaultSortDirection?: string;
    @observable filterFormStore: FormStore<any>;
    @observable searchFormStore: FormStore<SearchForm>;

    loadMoreData(props: any, module: any) {

    }

    load(props: any, module: any) {
        this.listTableStore = this.props.listTableStore;
        if (this.defaultSortColumn && this.defaultSortDirection) {
            this.listTableStore.setOrder(this.defaultSortColumn, this.defaultSortDirection);
        } else if (this.defaultSortColumn) {
            this.listTableStore.setOrder(this.defaultSortColumn, 'asc');
        }
        this.listTableStore.load();

        const filterFormClass = module[this.modelName + 'FilterForm'];
        this.filterFormStore = new FormStore(new filterFormClass());
        this.filterFormStore.onChangeCallback = debounce((data: any) => {
            this.listTableStore.setFilters(data);
        }, 200);

        this.searchFormStore = new FormStore(new SearchForm());
        this.searchFormStore.onChangeCallback = debounce((data: any) => {
            this.listTableStore.setSearch(data.search);
        }, 200);

        this.loadMoreData(props, module);

        this.isLoading = false;
    }

    getColumns() {
        const columns = this['colums'] ? this['colums']() : [];
        const actions = this['actions'] ? this['actions']() : this.defaultActions();
        const idColumn = this['idColumn'] ? this['idColumn']() : this.defaultIdColumn();

        return [
            idColumn,
            ...columns,
            ...actions,
        ]
    }

    defaultIdColumn() {
        return {
            name: "id",
            label: "#",
            style: {width: 50,},
        }
    }

    defaultActions() {
        return {
            name: "id",
            label: "Actions",
            formatter: (value: any) => {
                return (
                    <>
                        <HasPermission module={snakeCase(this.modelName)} permission="edit">
                            <Button color="grid" onClick={() => this.props.onEdit(value)} size="sm" className="btn-edit"><span className="icon-edit"/></Button>
                        </HasPermission>
                        {" "}
                        <HasPermission module={snakeCase(this.modelName)} permission="delete">
                            <Button color="grid" onClick={() => this.props.onDelete(value)} size="sm" className="btn-delete"><span className="icon-delete"/></Button>
                        </HasPermission>
                    </>
                );
            },
            style: {whiteSpace: 'nowrap', textAlign: 'center'},
        }
    }

    renderSearch() {
        return (
            <Field
                placeholder="Search"
                name="search"
                component={Input}
                required={true}
                store={this.searchFormStore}
                addon={{
                    type: 'append',
                    component: <span className="icon-search"/>
                }}
            />
        );
    }

    renderTable() {
        return <ListTable
            store={this.listTableStore}
            columns={this.getColumns()}
        />
    }

    render() {
        if (this.isLoading) {
            return <></>;
        }

       return (
           <>
               <div className="d-flex">
                   <div className="flex-grow-1">
                       {this['renderFilters'] && this['renderFilters']()}
                   </div>
                   {
                       this.props.actionComponent &&
                       <div className="ml-2">
                           {this.props.actionComponent}
                       </div>
                   }
               </div>
               {this.renderTable()}
           </>
       );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/crud/CrudList.tsx